module.exports = __webpack_public_path__ + "static/media/Send_white.2986d708.png";